import { TableContainer, Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import IconSelectorInputModal from '@components/Inputs/IconSelectorInputModal';
import { useTranslation } from 'react-i18next';
import WrapperEntitySelector from '@modules/entitySelector/WrapperEntitySelector';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';

const POSSIBLE_ACTIONS = [
  {
    id: 'default',
    label: 'Default',
    propGeneral: 'mapIcon',
    propSelected: 'clickedIcon',
  },
  {
    id: 'live',
    label: 'Live',
    propGeneral: 'mapLiveIcon',
    propSelected: 'clickedLiveIcon',
  },
];

const LIVE = 'live';

interface RulesetIconProps {
  action: any;
  onChange: (value: any) => void;
  disabled: boolean;
}

const RulesetIcons = ({ disabled, action, ...props }: RulesetIconProps) => {
  const { t } = useTranslation();
  const actionData = action.data;

  const onSelectIcon = icon => value => {
    const newIcon = {
      ...action,
      data: { ...action.data, [icon]: value },
    };
    props.onChange(newIcon);
  };

  return (
    <TableContainer component={Paper} sx={{ marginBottom: 20, marginTop: 20 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>{t('Icon')}</TableCell>
            <TableCell>{t('Selected Icon')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {POSSIBLE_ACTIONS.map((possibleAction, idx) => (
            <TableRow key={idx}>
              <TableCell>{t(possibleAction.label)}</TableCell>
              <TableCell>
                {possibleAction.id !== LIVE ? (
                  <IconSelectorInputModal
                    {...props}
                    disabled={disabled}
                    onSelectIcon={onSelectIcon(possibleAction.propGeneral)}
                    selectedIcon={actionData[possibleAction.propGeneral]}
                  />
                ) : (
                  <WrapperEntitySelector
                    label={'Indicator type'}
                    searchComponent={generateSearchEntitySelector('indicatorType')}
                    isReadOnly={disabled}
                    value={actionData[possibleAction.propGeneral]}
                    onChangeEntity={onSelectIcon(possibleAction.propGeneral)}
                  />
                )}
              </TableCell>
              <TableCell>
                {possibleAction.id !== LIVE ? (
                  <IconSelectorInputModal
                    {...props}
                    disabled={disabled}
                    onSelectIcon={onSelectIcon(possibleAction.propSelected)}
                    selectedIcon={actionData[possibleAction.propSelected]}
                  />
                ) : (
                  <WrapperEntitySelector
                    label={'Indicator type'}
                    searchComponent={generateSearchEntitySelector('indicatorType')}
                    isReadOnly={disabled}
                    value={actionData[possibleAction.propSelected]}
                    onChangeEntity={onSelectIcon(possibleAction.propSelected)}
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RulesetIcons;
